export const GET_EBS_ORGANIZATIONS = `
    query GetEbsOrganizations {
        getEbsOrganizations {
            organizationId
            organizationCode
            description
        }
    }
`;
